import { Component } from '@angular/core';

@Component({
	selector: 'home',
	styleUrls: ['./home.component.scss'],
	templateUrl: './home.component.html'
})
export class HomeComponent {

}



// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/home/home.component.ts